/*
export function someMutation (state) {
}
*/

import {LocalStorage} from 'quasar'

export const ADMINISTRACAO_ANO_CORRENTE = (state, data) => {
  state.ano = data.ano
  state.administracao = data.administracao
  LocalStorage.set('anoCorrente', state.ano)
  LocalStorage.set('administracaoCorrente', state.administracao)
}
